import api from '../utils/api';

export const getTimecards = async (projectId, { weekStart } = {}) => {
  const params = {};
  if (weekStart) params.weekStart = weekStart;
  const res = await api.get(`/payroll/${projectId}/timecards`, { params });
  return res.data?.data?.timecards || [];
};

export const getMyTimecard = async (projectId, { weekStart } = {}) => {
  const params = {};
  if (weekStart) params.weekStart = weekStart;
  const res = await api.get(`/payroll/${projectId}/my-timecard`, { params });
  return res.data?.data?.timecard || null;
};

export const upsertTimecard = async (projectId, payload) => {
  const res = await api.post(`/payroll/${projectId}/timecards`, payload);
  return res.data?.data?.timecard || null;
};

export default {
  getTimecards,
  getMyTimecard,
  upsertTimecard,
};
